import styled from "styled-components";

export const Step = styled.div<{ $isActive: boolean }>`
  height: 6px;
  width: 6px;
  box-sizing: content-box;
  border: 5px solid ${"#e6f4ff"};
  border-radius: 50%;

  background-color: ${(props) => (props.$isActive ? "#1677ff" : "#e6f4ff")};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  .stepper-connector {
    height: 2px;
    width: 72px;
    background-color: ${"#e6f4ff"};
  }
`;
